module.exports = __webpack_public_path__ + "static/img/dy.80e6824.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/mother/dy.png
// module id = ZbSz
// module chunks = 1